import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./header/header";
import "./EnrollFormSuccess.css";


const PENDING_KEYS = [
  "handsonexpFormInfo",
  "handsonexpEmailToUser",
  "handsonexpEmailToDoyen",
  "handsonexpPayment",
  "sessiontrackidss",
];

const EnrollFormCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    PENDING_KEYS.forEach((k) => localStorage.removeItem(k));
  }, []);

  const handleGoBack = () => {
    navigate("/"); // This will navigate back to the home page
  };

  return (
    <div>
      <Header />

      <div style={{ width: "100%", overflowX: "hidden", overflowY: "hidden" }}>
        <div className="text-center successenrollform">
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div
                style={{
                  backgroundColor: "#f5f8f8",
                  borderRadius: "10px",
                  paddingTop: "25px",
                  paddingBottom: "55px",
                }}
              >
                <img
                  src="../../images/Cancelimg.png"
                  alt="cancelimg"
                  style={{ paddingBottom: "30px", paddingLeft: "200px" }}
                />
                <h2>Transaction Cancelled</h2>
                <button className="btn btn-danger" onClick={handleGoBack}>
                  Back to Home
                </button>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EnrollFormCancel;
